import {configManager} from './config-manager/config-manager';
import {ConfigService} from '@nuskin/ns-util';

export var localeUtil = (function() {
    // ---------------------------------------------------------------------------
    //
    //                           Public Methods
    //
    // ---------------------------------------------------------------------------
    var publicMethods = {

        getLocaleFromPath: function(path) {
            var parts = path.split('/');
            var locale = null;
            // var lastElement = parts.length - 1;
            for (var i=0; i < parts.length; i++) {
                if (parts[i].length == 2 && parts[i+1].length == 2) {
                    try {
                        locale = publicMethods.toLocale(parts[i+1]+'_'+parts[i]);
                        break;
                    } catch (e) {
                    }
                } else if (parts.length == 5 && parts[i].includes('.html')) {
                    try {
                        var country = parts[i].slice(0, 2);
                        locale = publicMethods.toLocale('en'+'_'+country);
                    } catch (e) {

                    }
                }
            }
            return locale;
        },
        toLocale: function(str) {
            if (str == null) {
                return null;
            }

            var len = str.length;
            if (len != 2 && len != 5 && len < 7) {
                throw 'Invalid locale format: ' + str;
            }

            var ch0 = str.charAt(0);
            var ch1 = str.charAt(1);
            if (ch0 < 'a' || ch0 > 'z' || ch1 < 'a' || ch1 > 'z') {
                throw 'Invalid locale format: ' + str;
            }

            if (len == 2) {
                return new publicMethods.Locale(str, '');
            } else {
                if (str.charAt(2) != '_') {
                    throw 'Invalid locale format: ' + str;
                }
                var ch3 = str.charAt(3);
                if (ch3 == '_') {
                    return new publicMethods.Locale(str.substring(0, 2), '', str.substring(4));
                }
                var ch4 = str.charAt(4);
                if (ch3 < 'A' || ch3 > 'Z' || ch4 < 'A' || ch4 > 'Z') {
                    throw 'Invalid locale format: ' + str;
                }
                if (len == 5) {
                    return new publicMethods.Locale(str.substring(0, 2), str.substring(3, 5), '');
                } else {
                    if (str.charAt(5) != '_') {
                        throw 'Invalid locale format: ' + str;
                    }
                    return new publicMethods.Locale(str.substring(0, 2), str.substring(3, 5), str.substring(6));
                }
            }
        },
        Locale: function(language, country, variant) {
            var lang = language;
            var cntry = country;
            var varnt = variant;

            this.getLanguage = function() {
                return lang;
            };
            this.getCountry = function() {
                return cntry;
            };
            this.getVariant = function() {
                return varnt;
            };
        },
        replaceUrlLocale: function(aUrl, countryCode, languageCode) {
            try {
                // varifying that market contains the passed in languageCode
                var matchCountry = /[a-z]{2}_[A-Z]{2}/;
                var request = new XMLHttpRequest();
                request.open('GET', '/content/localization/countryandlanguagetranslation.service.en.json', false);
                request.send();
                if (request.status === 200) {
                    var response = JSON.parse(request.response);
                    if (response[countryCode].languages[languageCode]) {
                        // changing url to country and language provided
                        aUrl = aUrl.replace(matchCountry, languageCode + '_' + countryCode);
                    } else {
                        // get first language in market
                        aUrl = aUrl.replace(matchCountry, Object.keys(abc[countryCode].languages)[0] + '_' + countryCode);
                    }
                    var otherConfig = ConfigService.getMarketConfig(null, countryCode);
                    if(otherConfig.useNewProfile) {
                        return aUrl;
                    } else {
                        return aUrl.replace(/([a-z]{2}_[A-Z]{2}).*/, '$1/preferences.html');
                    }
                }
            }
            catch(e) {console.log(e);}
            return '/nuskin.html';
        }
    };

    return publicMethods;
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/locale-util.js
// module id = 282
// module chunks = 0